<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { formatedDate } from "../../../utils/proposalValidation";

export default {
    name: "CPTemp12",
    components: {
        SpellCheckedText,
        PhotoBox
    },
    props: {
        projects: { type: Object, required: true },
        pageGap: { type: Boolean, default: true },
        startPage: { type: Number, default: 1 },
    },
    data() {
        return {
            footerImage: ""
        };
    },
    computed: {
        projectPages() {
            return this.projects.projects || [];
        }
    },
    methods: {
        formatedDate,
        generateGradients() {
            const fCanvas = document.createElement('canvas');
            fCanvas.width = 1150;
            fCanvas.height = 400;
            const fCtx = fCanvas.getContext('2d');
            const fGrad = fCtx.createLinearGradient(0, 400, 0, 0);
            fGrad.addColorStop(0, 'rgba(0, 0, 0, 0.8)');
            fGrad.addColorStop(1, 'rgba(0, 0, 0, 0)');
            fCtx.fillStyle = fGrad;
            fCtx.fillRect(0, 0, 1150, 400);
            this.footerImage = fCanvas.toDataURL();
        }
    },
    mounted() {
        this.generateGradients();
    }
};
</script>

<template>
    <div class="main-container" :style="{
        gap: pageGap ? '20px' : '0px',
        '--header-color': projects.style.colorScheme.header,
        '--body-color': projects.style.colorScheme.body,
        '--footer-color': projects.style.colorScheme.footer,
        '--heading-color': projects.style.heading.color,
        '--heading-size': projects.style.heading.size + 'px',
        '--heading-font': projects.style.heading.font,
        '--heading-weight': projects.style.heading.bold ? 'bold' : 'normal',
        '--heading-style': projects.style.heading.italic ? 'italic' : 'normal',
        '--heading-decoration': projects.style.heading.underline ? 'underline' : 'none',
        '--label-color': projects.style.label.color,
        '--label-size': projects.style.label.size + 'px',
        '--label-font': projects.style.label.font,
        '--label-weight': projects.style.label.bold ? 'bold' : 'normal',
        '--label-style': projects.style.label.italic ? 'italic' : 'normal',
        '--label-decoration': projects.style.label.underline ? 'underline' : 'none',
        '--text-color': projects.style.text.color,
        '--text-size': projects.style.text.size + 'px',
        '--text-font': projects.style.text.font,
        '--text-weight': projects.style.text.bold ? 'bold' : 'normal',
        '--text-style': projects.style.text.italic ? 'italic' : 'normal',
        '--text-decoration': projects.style.text.underline ? 'underline' : 'none',
    }">
        <div v-for="(project, index) in projectPages" :key="index" class="sub-container page-unit">
            <div class="split-layout">
                <!-- TOP CONTENT ROW -->
                <div class="top-row">

                    <div class="section-header">
                        <SpellCheckedText :value="projects.title || ''" @input="projects.title = $event" />
                    </div>

                    <div v-if="project && footerImage" class="bottom-gradient">
                        <img :src="footerImage" class="w-full h-full" />
                    </div>

                    <div class="main-image-wrapper photobox">
                        <PhotoBox :project="project" :index="0" height="100%" objectFit="cover"
                            :bgColor="projects.style.colorScheme && projects.style.colorScheme.body" />
                    </div>
                </div>

                <!-- BOTTOM ROW -->
                <div class="bottom-row">
                    <div class="content-wrapper">
                        <div class="project-details-area">
                            <h1 class="project-title">
                                <SpellCheckedText :value="project.projectName || 'N/A'"
                                    @input="project.projectName = $event" />,
                                <SpellCheckedText :value="project.city || 'N/A'" @input="project.city = $event" />
                                {{ " " }}
                                <SpellCheckedText :value="project.stateProvince || 'N/A'"
                                    @input="project.stateProvince = $event" />
                            </h1>

                            <div class="metadata-grid">
                                <p class="info-row">
                                    <span class="label">Client: </span>
                                    <span class="value">
                                        <SpellCheckedText :value="project.clientAccountName || 'N/A'"
                                            @input="project.clientAccountName = $event" />
                                    </span>
                                </p>
                                <p class="info-row">
                                    <span class="label">Designers: </span>
                                    <span class="value">
                                        <span
                                            v-if="!project.designerAccounts || project.designerAccounts.length == 0">N/A</span>
                                        <span v-else v-for="(designer, index) in project.designerAccounts" :key="index">
                                            <SpellCheckedText :value="designer.accountName || 'N/A'"
                                                @input="designer.accountName = $event" />
                                            <span v-if="index !== project.designerAccounts.length - 1">,</span>
                                        </span>
                                    </span>
                                </p>
                                <p class="info-row">
                                    <span class="label">Construction Cost: </span>
                                    <span class="value">{{ project.value ? `$${project.value.toLocaleString()}` : 'N/A'
                                    }}</span>
                                </p>
                                <p class="info-row">
                                    <span class="label">Construction Duration: </span>
                                    <span class="value">{{ formatedDate(project.constructionStartDate) || 'N/A' }} to {{
                                        formatedDate(project.constructionCompletionDate) || 'N/A'
                                    }}</span>
                                </p>
                            </div>

                            <div class="description-section" v-if="project.projectDetails">
                                <h3 class="subsection-title">Project Description</h3>
                                <div class="description-content">
                                    <SpellCheckedText :value="project.projectDetails || ''"
                                        @input="project.projectDetails = $event" />
                                </div>
                            </div>
                        </div>

                        <div v-if="project.projectTeam && project.projectTeam.length > 0" class="team-list">
                            <div v-for="(member, mIdx) in project.projectTeam" :key="mIdx" class="team-member">
                                <div class="member-avatar photobox">
                                    <PhotoBox class="photobox" :project="member"
                                        :bgColor="projects.style.colorScheme.body" type="profile" />
                                </div>
                                <div class="member-text">
                                    <span>
                                        <SpellCheckedText :value="member.name" @input="member.name = $event" />
                                    </span>
                                    <span v-if="member.role"> - </span>
                                    <span v-if="member.role">
                                        <SpellCheckedText :value="member.role" @input="member.role = $event" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer-section">
                        <div class="bottom-page-info">
                            <SpellCheckedText :value="projects.opprName || ''" @input="projects.opprName = $event" />
                        </div>
                        <div class="footer-right">
                            <SpellCheckedText :value="projects.submittedBy" @input="projects.submittedBy = $event"
                                class="company-name" />
                            <span class="page-divider">|</span>
                            <span class="page-number">{{ startPage + index }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main-container {
    display: flex;
    flex-direction: column;
    width: 297mm;
    min-height: 210mm;
    position: relative;
    box-sizing: border-box;

    &:hover {
        .photobox :deep(.photo-overlay) {
            opacity: 1;
        }

        .photobox :deep(img) {
            opacity: 0.9;
        }
    }

    .sub-container {
        display: flex;
        flex-direction: column;
        background: white;
        width: 297mm;
        height: 210mm;
        position: relative;
        overflow: hidden;
    }

    .split-layout {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    .top-row {
        height: 60%;
        width: 100%;
        position: relative;
        background: var(--body-color);

        .main-image-wrapper {
            width: 100%;
            height: 100%;
            overflow: hidden;
        }

        .bottom-gradient {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 150px;
            z-index: 2;
            pointer-events: none;
        }

        .section-header {
            position: absolute;
            top: 10px;
            right: 0px;
            z-index: 50;
            padding: 10px 40px;
            color: var(--header-color);
            font-size: 14px;
            font-weight: bold;
            font-family: Helvetica;
            margin-bottom: 5px;
            text-align: right;
        }
    }

    .bottom-row {
        height: 40%;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 15px 20px;
        background: var(--footer-color);
        position: relative;
        z-index: 2;

        .content-wrapper {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            min-height: 0;

            .project-details-area {
                overflow: hidden;
                min-height: 0;

                .project-title {
                    color: var(--heading-color);
                    font-size: var(--heading-size);
                    font-weight: var(--heading-weight);
                    font-family: var(--heading-font);
                    font-style: var(--heading-style);
                    text-decoration: var(--heading-decoration);
                    margin-bottom: 0px;
                    line-height: 1;
                }

                .metadata-grid {
                    display: flex;
                    flex-direction: row;
                    margin-bottom: 8px;
                    gap: 10px;

                    .info-row {
                        margin: 0;

                        .label {
                            color: var(--label-color);
                            font-size: var(--label-size);
                            font-weight: var(--label-weight);
                            font-family: var(--label-font);
                            font-style: var(--label-style);
                            text-decoration: var(--label-decoration);
                            flex-shrink: 0;
                        }

                        .value {
                            color: var(--text-color);
                            font-size: var(--text-size);
                            font-weight: var(--text-weight);
                            font-family: var(--text-font);
                            font-style: var(--text-style);
                            text-decoration: var(--text-decoration);
                        }
                    }
                }

                .description-section {
                    .subsection-title {
                        color: var(--label-color);
                        font-size: var(--label-size);
                        font-weight: var(--label-weight);
                        font-family: var(--label-font);
                        font-style: var(--label-style);
                        text-decoration: var(--label-decoration);
                        margin-bottom: 8px;
						text-align:left;
                    }

                    .description-content {
                        color: var(--text-color);
                        font-size: var(--text-size);
                        font-weight: var(--text-weight);
                        font-family: var(--text-font);
                        font-style: var(--text-style);
                        text-decoration: var(--text-decoration);
                        white-space: pre-wrap;
                        line-height: 1.2;
                        padding-bottom: 5px;
                    }
                }
            }

            .team-list {
                display: flex;
                flex-direction: row;
                gap: 10px;
                padding-bottom: 5px;
                flex-shrink: 0;

                .team-member {
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    .member-avatar {
                        width: 38px;
                        height: 38px;
                        border-radius: 50%;
                        overflow: hidden;
                        background: #eee;
                        flex-shrink: 0;
                        background-color: var(--body-color);

                        &:hover {
                            .photobox :deep(.photo-overlay) {
                                gap: 0px;
                            }

                            .photobox :deep(.overlay-btn) {
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }

                    .member-text {
                        font-size: var(--text-size);
                        color: var(--text-color);
                        font-weight: var(--text-weight);
                        font-family: var(--text-font);
                        font-style: var(--text-style);
                        text-decoration: var(--text-decoration);
                        margin: 0;
                    }
                }
            }
        }

        .footer-section {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            font-family: Helvetica, ;
            font-weight: bold;
            color: black;
            margin-top: auto;

            .bottom-page-info {
                font-size: 12px;
            }

            .footer-right {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .page-divider {
                font-size: 12px;
                margin: 0;
                padding: 0px 10px;
            }

            .company-name {
                font-size: 12px;
                margin: 0;
            }

            .page-number {
                font-size: 16px;
                margin: 0;
            }
        }

    }
}
</style>
